/**
 * Copied from openlibrary/openlibrary/plugins/openlibrary/js/nonjquery_utils.js
 * which copied from:
 * https://davidwalsh.name/javascript-debounce-function which copied from underscore.js
 * @module components/util/debounce
 */

/**
 * Debounce func
 * i.e. Returns a function, that, as long as it continues to be invoked, will not
 * be triggered until it stops being called for `threshold` milliseconds. If
 * `execAsap` is passed, trigger the function first, then block it.
 * @param {Function} func
 * @param {Number} [threshold]
 * @param {Boolean} [execAsap]
 * @returns {Function}
 */
export function debounce(func, threshold = 100, execAsap = false) {
  let timeout;
  return function debounced() {
    const args = arguments;
    const delayed = () => {
      if (!execAsap)
        func.apply(this, ...args);
      timeout = null;
    };

    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      func.apply(this, ...args);
    }
    timeout = setTimeout(delayed, threshold);
  };
}
